var _rect, _circle, _circle2, _g, _rect2, _circle3, _circle4, _g2, _rect3, _circle5, _circle6, _g3, _rect4, _circle7, _circle8, _g4, _rect5, _circle9, _circle0, _g5, _rect6, _circle1, _circle10, _g6, _path, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _rect7, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveNaturalLightExposure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 151,
    viewBox: "0 0 249 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.933,
    y: 77.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 115.933 77.9784)",
    stroke: "#DBEFF7",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 146.885,
    cy: 104.885,
    r: 28,
    transform: "rotate(-4 146.885 104.885)",
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11322_9761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 76,
    width: 57,
    height: 57
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.885,
    cy: 104.885,
    r: 28,
    transform: "rotate(-4 146.885 104.885)",
    fill: "#D56D37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11322_9761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.586,
    cy: 102.887,
    r: 25.8462,
    transform: "rotate(-4 144.586 102.887)",
    fill: "#EEAA3C"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.949,
    y: 2.98437,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 83.949 2.98437)",
    stroke: "#DBEFF7",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.427,
    cy: 30.4269,
    r: 28,
    transform: "rotate(-3 114.427 30.4269)",
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11322_9761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 2,
    width: 57,
    height: 57
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.427,
    cy: 30.4269,
    r: 28,
    transform: "rotate(-3 114.427 30.4269)",
    fill: "#D56D37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11322_9761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112.163,
    cy: 28.3887,
    r: 25.8462,
    transform: "rotate(-3 112.163 28.3887)",
    fill: "#EEAA3C"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9784,
    y: 59.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 71.9784 59.9327)",
    stroke: "#DBEFF7",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8849,
    cy: 90.885,
    r: 28,
    transform: "rotate(4 98.8849 90.885)",
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11322_9761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 62,
    width: 57,
    height: 57
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8849,
    cy: 90.885,
    r: 28,
    transform: "rotate(4 98.8849 90.885)",
    fill: "#D56D37"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11322_9761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.8865,
    cy: 88.5861,
    r: 25.8462,
    transform: "rotate(4 96.8865 88.5861)",
    fill: "#EEAA3C"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158.83,
    y: 46.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 158.83 46.8706)",
    stroke: "#DBEFF7",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.107,
    cy: 75.1066,
    r: 24,
    transform: "rotate(8 180.107 75.1066)",
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11322_9761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 51,
    width: 49,
    height: 49
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.107,
    cy: 75.1066,
    r: 24,
    transform: "rotate(8 180.107 75.1066)",
    fill: "#D56D37"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11322_9761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 178.536,
    cy: 73.0215,
    r: 22.1538,
    transform: "rotate(8 178.536 73.0215)",
    fill: "#EEAA3C"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.831254,
    y: -1.14412,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 93.2404 22.8559)",
    stroke: "#DBEFF7",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 91.4092 23)",
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11322_9761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 26,
    width: 49,
    height: 49
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 91.4092 23)",
    fill: "#D56D37"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11322_9761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.1538,
    cy: 22.1538,
    r: 22.1538,
    transform: "matrix(-0.987688 0.156434 0.156434 0.987688 91.4092 23)",
    fill: "#EEAA3C"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.909039,
    y: -1.08335,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 176.726 20.9166)",
    stroke: "#DBEFF7",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 174.817 21)",
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11322_9761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 22,
    width: 50,
    height: 50
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 174.817 21)",
    fill: "#D56D37"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11322_9761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.1538,
    cy: 22.1538,
    r: 22.1538,
    transform: "matrix(-0.996195 0.0871557 0.0871557 0.996195 174.817 21)",
    fill: "#EEAA3C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 93C50 91.8954 50.8954 91 52 91H72.2654C73.2607 91 74.1046 91.7319 74.2453 92.7172L77.7547 117.283C77.8954 118.268 78.7393 119 79.7346 119H180.265C181.261 119 182.105 118.268 182.245 117.283L185.755 92.7172C185.895 91.7319 186.739 91 187.735 91H208C209.105 91 210 91.8954 210 93V119V145C210 146.105 209.105 147 208 147H178H82H52C50.8954 147 50 146.105 50 145V119V93Z",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 126.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 45.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 45.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 114.5,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.5,
    cy: 15.5,
    r: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 22 151)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197 29L217 21.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222 77L238 80",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17L33 24",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79L20 84",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveNaturalLightExposure);
export default __webpack_public_path__ + "static/media/collective-natural-light-exposure.41a6db1362dfecf5b34509e422b4f215.svg";
export { ForwardRef as ReactComponent };